import {Button} from '@nlabs/gothamjs';

import {Hero} from '../../components/Hero';
import {Page} from '../../components/Page';
import {Section} from '../../components/Section';
import ufatPortalSigninHero from '../../assets/ufat-portal-signin-hero.png';
import {navigate} from '../../lib/navigation';
import {buttonOutlineDark, card, cardContent, cardTitle, gridThree, paragraphMuted} from '../../lib/styles';
import {Route} from '../../types/routes';

export const Portal = ({route}: {route: Route}) => (
  <Page route={route}>
    <Hero
      actions={(
        <Button className={buttonOutlineDark} onClick={() => navigate('/support')}>Contact Support</Button>
      )}
      aside={(
        <form className="grid gap-4 rounded-[var(--nx-radius)] border border-[rgba(16,22,36,.12)] bg-white/64 p-[clamp(20px,3vw,30px)] text-[var(--nx-ink)] shadow-2xl backdrop-blur-xl" onSubmit={(event) => event.preventDefault()}>
          <div className="grid gap-1">
            <h2 className="m-0 text-[1.45rem] leading-tight text-[var(--nx-ink)]">Sign in</h2>
            <p className="m-0 text-sm leading-[1.6] text-[rgba(19,26,43,.68)]">Creator accounts are reserved for phase 2 access.</p>
          </div>
          <label className="grid gap-2 text-sm font-bold text-[rgba(19,26,43,.82)]">Username
            <input className="min-h-12 rounded-[var(--nx-radius)] border border-[rgba(16,22,36,.18)] bg-white/70 px-3 py-2.5 text-[var(--nx-ink)] outline-none transition-colors placeholder:text-[rgba(19,26,43,.38)] focus:border-[rgba(16,22,36,.5)]" name="username" placeholder="creator@example.com" type="text" />
          </label>
          <label className="grid gap-2 text-sm font-bold text-[rgba(19,26,43,.82)]">Password
            <input className="min-h-12 rounded-[var(--nx-radius)] border border-[rgba(16,22,36,.18)] bg-white/70 px-3 py-2.5 text-[var(--nx-ink)] outline-none transition-colors placeholder:text-[rgba(19,26,43,.38)] focus:border-[rgba(16,22,36,.5)]" name="password" placeholder="Password" type="password" />
          </label>
          <Button className={`${buttonOutlineDark} w-full`} disabled type="submit">Sign In Coming Soon</Button>
        </form>
      )}
      backgroundImage={ufatPortalSigninHero}
      copyTone="dark"
      imageLabel="Creator portal placeholder image"
      hideImageLabel
      kicker="Creator portal"
      subtitle="A reserved sign-in surface for phase 2 creator accounts, manuscript uploads, production tasks, proof reviews, and publishing status."
      title="Creator sign-in is coming next."
      tone="cyan"
    />
    <Section className="nx-section-projects-alt" title="Portal preview">
      <div className="grid gap-[18px] min-[841px]:grid-cols-[.9fr_1.1fr]">
        <form className="grid gap-[18px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] bg-white p-[clamp(22px,4vw,36px)]" onSubmit={(event) => event.preventDefault()}>
          <label className="grid gap-2 font-extrabold text-[var(--nx-ink)]">Email<input className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" disabled placeholder="creator@example.com" type="email" /></label>
          <label className="grid gap-2 font-extrabold text-[var(--nx-ink)]">Password<input className="min-h-[46px] rounded-[var(--nx-radius)] border border-[var(--nx-line)] px-3 py-2.5 text-[var(--nx-text)]" disabled placeholder="Phase 2 authentication" type="password" /></label>
          <Button className={buttonOutlineDark} disabled type="submit">Sign In Coming Soon</Button>
          <p className="m-0 rounded-[var(--nx-radius)] bg-[var(--nx-soft)] p-3.5 text-sm leading-[1.6] text-[var(--nx-muted)]">
            Accounts are not active yet. Creators should start from the publishing page first.
          </p>
        </form>
        <div className={gridThree}>
          <div className={card}>
            <div className={cardContent}>
              <h3 className={cardTitle}>Secure uploads</h3>
              <p className={paragraphMuted}>PDFs, proposals, cover files, media samples, and production-ready assets.</p>
            </div>
          </div>
          <div className={card}>
            <div className={cardContent}>
              <h3 className={cardTitle}>Review status</h3>
              <p className={paragraphMuted}>Submission intake, editorial review, production review, proofs, and launch readiness.</p>
            </div>
          </div>
          <div className={card}>
            <div className={cardContent}>
              <h3 className={cardTitle}>Format planning</h3>
              <p className={paragraphMuted}>Hardcover, softcover, ebook, metadata, ISBN, distribution, and media extension notes.</p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  </Page>
);
